import React, { useRef, useState } from 'react';
import { ADD_TO_ORDER, KIDS_COMBO, TRY_2_COMBO } from '../../../../constants';
import { IApplyButton } from '../../../../models/try2Combo';
import styleClasses from '../../try2.module.scss';

const ApplyButton: React.FC<IApplyButton> = ({ isDisabled,selectedOtherDressingData,clickHandle, btnClass, btnSize, usingIn = TRY_2_COMBO,label="Apply", price}) => {

  const [loading, setLoading] = useState<boolean>(false);

  const disableButtonClick = useRef(false);


  const onClick = () => {
    if(usingIn?.toLowerCase() === KIDS_COMBO.toLowerCase()) {
      if(!isDisabled && !loading) {
        setLoading(true)
        clickHandle()
      }
    }else{
    if(disableButtonClick.current) return;
    if(!isDisabled) {
      clickHandle();
      disableButtonClick.current = true;
      setTimeout(() => {
      disableButtonClick.current = false;
      },500)
    }
  }

  }

  const showPrice = label === ADD_TO_ORDER && price;
  
  return (
    <button
      type="button"
      className={`${styleClasses.try2_item_order_btn} btn btn-large ms-0 ${btnSize} ${btnClass} ${isDisabled && 'btn-disabled-grey'}`}
      onClick={onClick}
      data-testid="modal-apply-Button"
    >
      {showPrice ? (
        <span className="btn-inner-wrap">
          <span>{label}</span>
          <span className="btn-price-loader-slot">
            <span>{`$${price}`}</span>
          </span>
        </span>
      ) : label}
    </button>
  );
};

export default ApplyButton;
